import React, { useState, useEffect } from 'react'
import useRequest from '../../../../axios/apis/useRequest'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  Card,
  Table,
  Button,
  ButtonGroup,
  Dropdown,
} from '@themesberg/react-bootstrap'
import TableDate from '../../Shared/TableDate/TableDate'
import { useDispatch, useSelector } from 'react-redux'
import {
  PlansChangeAttr,
  deletePlan,
  setAllPlans,
} from '../../../../store/slices/products/productsSlice.js'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  faEdit,
  faEllipsisH,
  faEye,
  faEyeSlash,
  faToggleOff,
  faToggleOn,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons'

import DeleteConfirmation from '../../global/DeleteConfirmation/DeleteConfirmation'
import PlanForm from './PlanForm/PlanForm'
import ThemeDialog from '../../Shared/ThemeDialog/ThemeDialog'
import DescriptionCell from '../../Shared/DescriptionCell/DescriptionCell'
import { Wrapper } from './ProductPlansList.styled'
import { toast } from 'react-toastify'
import {
  BsCheck,
  BsFillBagCheckFill,
  BsFillBagDashFill,
  BsFillCheckCircleFill,
  BsFillXCircleFill,
  BsPencilSquare,
  BsShare,
} from 'react-icons/bs'
import Label from '../../Shared/label/Label'

import {
  MdOutlineUnpublished,
  MdOutlinePublishedWithChanges,
  MdSort,
} from 'react-icons/md'

import { PublishStatus } from '../../../../const'
import DynamicButtons from '../../Shared/DynamicButtons/DynamicButtons'
import { setActiveIndex } from '../../../../store/slices/tenants'
import { GiShadowFollower } from 'react-icons/gi'
import {
  systemLockStatus,
  tenancyTypeEnum,
  booleanStatus,
  visibilityStatus,
  SelectabilityStatus,
  textLocale,
} from '../../../../const/product.js'
import { dynamicButtonsLanguages } from '../../../../const/const.js'
import SafeFormatMessage from '../../Shared/SafeFormatMessage/SafeFormatMessage.jsx'
import useSharedFunctions from '../../Shared/SharedFunctions/SharedFunctions.jsx'
import DataLabelWhite from '../../Shared/DateLabelWhite/DateLabelWhite.jsx'

export const ProductPlansList = ({
  productId,
  quickSetup,
  setSelectedItemId,
  setVisibleQuickSetup,
  setFormType,
}) => {
  const { getProductPlans, deletePlanReq, publishPlan, visiblePlan } =
    useRequest()
  const [update, setUpdate] = useState(1)
  const dispatch = useDispatch()
  const list = useSelector((state) => state.products.products[productId])
  const [currentId, setCurrentId] = useState('')
  const [confirm, setConfirm] = useState(false)
  const [visible, setVisible] = useState(false)
  const [type, setType] = useState('')
  const [popUpLable, setPopUpLable] = useState('')
  const intl = useIntl()
  const ProductTrialType = list?.trialType
  const [selectedLanguage, setSelectedLanguage] = useState(intl.locale)

  const handleDeletePlan = async () => {
    if (list?.plans[currentId]?.isSubscribed) {
      toast.error(
        intl.formatMessage({ id: 'Cannot-delete-a-subscribed-plan.' }),
        {
          position: toast.POSITION.TOP_CENTER,
        }
      )
      return
    }
    if (list?.plans[currentId]?.isLockedBySystem) {
      toast.error(intl.formatMessage({ id: 'Cannot-delete-a-locked-plan' }), {
        position: toast.POSITION.TOP_CENTER,
      })
      return
    }
    await deletePlanReq(productId, { id: currentId })
    dispatch(deletePlan({ productId, PlanId: currentId }))
  }

  const deleteConfirm = (id) => {
    setCurrentId(id)
    setConfirm(true)
  }

  const editForm = async (id) => {
    if (quickSetup) {
      setSelectedItemId(id)
      setVisibleQuickSetup(true)
      setFormType('edit')
      return
    }
    if (list?.plans[id]?.isSubscribed) {
      toast.error(
        intl.formatMessage({ id: 'Cannot-edit-a-subscribed-plan.' }),
        {
          position: toast.POSITION.TOP_CENTER,
        }
      )
      return
    }
    if (list?.plans[id]?.isLockedBySystem) {
      toast.error(intl.formatMessage({ id: 'Cannot-edit-a-locked-plan' }), {
        position: toast.POSITION.TOP_CENTER,
      })
      return
    }
    setPopUpLable('Edit-Plan')
    setType('edit')
    setCurrentId(id)
    setVisible(true)
  }

  useEffect(() => {
    if (!productId) return
    ;(async () => {
      const listData = await getProductPlans(productId)
      dispatch(setAllPlans({ productId, data: listData.data.data }))
    })()
  }, [productId])
  const toggleVisiblePlan = async (id, isVisible) => {
    await visiblePlan(productId, {
      id,
      isVisible: !isVisible,
    })

    dispatch(
      PlansChangeAttr({
        productId,
        planId: id,
        attr: 'isVisible',
        value: !isVisible,
      })
    )
  }

  const togglePublishPlan = async (id, isPublished) => {
    await publishPlan(productId, {
      id,
      isPublished: !isPublished,
    })

    dispatch(
      PlansChangeAttr({
        productId,
        planId: id,
        attr: 'isPublished',
        value: !isPublished,
      })
    )
  }
  const filterRedirectionLink = (description) => {
    return description?.replace(/#redirection-link=([^\s]+)/, '') || ''
  }

  const TableRow = (props) => {
    const {
      displayName,
      systemName,
      description,
      id,
      displayOrder,
      createdDate,
      isPublished,
      editedDate,
      subscriptionsCount,
      isLockedBySystem,
      tenancyType,
      alternativePlanID,
      trialPeriodInDays,
      descriptionLocalizations,
      displayNameLocalizations,
      isAvailableForSelection,
      isVisible,
    } = props
    const publishStatus = isPublished ? true : false
    // const filteredDescription =
    //   filterRedirectionLink(descriptionLocalizations?.[selectedLanguage]) ||
    //   filterRedirectionLink(description)

    return (
      <tr>
        <td>
          <span className="fw-normal">
            {textLocale(displayNameLocalizations, selectedLanguage, intl)}
          </span>
        </td>
        <td>
          <span className="fw-normal">{systemName}</span>
        </td>
        <td>
          <span>
            <Label {...PublishStatus[publishStatus]} />
          </span>
        </td>
        {!quickSetup && (
          <td>
            <span>
              <Label {...SelectabilityStatus[isAvailableForSelection]} />
            </span>
          </td>
        )}
        <td>
          <span>
            <Label {...visibilityStatus[isVisible]} />
          </span>
        </td>
        {!quickSetup && (
          <td>
            <span>
              {<SafeFormatMessage id={tenancyTypeEnum[tenancyType]} />}
            </span>
          </td>
        )}
        {!quickSetup && (
          <td>
            <span
              className={`${
                subscriptionsCount > 0
                  ? 'subscribers-active'
                  : 'subscribers-passive'
              }`}
            >
              <GiShadowFollower />
              <span className="ml-1">
                {subscriptionsCount ? subscriptionsCount : 0}
              </span>
            </span>
          </td>
        )}
        {/*<td className="description">
          <DescriptionCell
            data={{
              description:
                descriptionLocalizations?.[selectedLanguage] || description,
            }}
          />
        </td>*/}
        {!quickSetup && (
          <td>
            <span className={`fw-normal`}>
              <DataLabelWhite
                variant={'gray'}
                text={
                  <>
                    <MdSort />
                    {'  '}
                    {displayOrder}
                  </>
                }
              />
            </span>
          </td>
        )}
        {!quickSetup && (
          <td>
            <span>{list.plans?.[alternativePlanID]?.displayName}</span>
          </td>
        )}
        {ProductTrialType == 3 && (
          <td>
            <span>{trialPeriodInDays}</span>
          </td>
        )}
        {!quickSetup && (
          <td>
            <span>
              <Label {...systemLockStatus[isLockedBySystem]} />
            </span>
          </td>
        )}
        {!quickSetup && (
          <td>
            <span className="fw-normal">
              <TableDate createdDate={createdDate} editedDate={editedDate} />
            </span>
          </td>
        )}
        <td>
          <Dropdown as={ButtonGroup}>
            <Dropdown.Toggle
              as={Button}
              split
              variant="link"
              className="text-dark m-0 p-0"
            >
              <span className="icon icon-sm">
                <FontAwesomeIcon icon={faEllipsisH} className="icon-dark" />
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onSelect={() => editForm(id)}>
                <FontAwesomeIcon icon={faEdit} className="mx-2" />
                <SafeFormatMessage id="Edit" />
              </Dropdown.Item>
              <Dropdown.Item onClick={() => togglePublishPlan(id, isPublished)}>
                {isPublished ? (
                  <span className=" ">
                    <MdOutlineUnpublished className="mx-2" />
                    <SafeFormatMessage id="Deactivate" />
                  </span>
                ) : (
                  <span className=" ">
                    <MdOutlinePublishedWithChanges className="mx-2" />
                    <SafeFormatMessage id="Activate" />
                  </span>
                )}
              </Dropdown.Item>
              <Dropdown.Item onClick={() => toggleVisiblePlan(id, isVisible)}>
                {isVisible ? (
                  <span className=" ">
                    <FontAwesomeIcon icon={faEye} className="mx-2" />
                    <SafeFormatMessage id="Hide-Plan" />
                  </span>
                ) : (
                  <span className=" ">
                    <FontAwesomeIcon icon={faEyeSlash} className="mx-2" />
                    <SafeFormatMessage id="Show-Plan" />
                  </span>
                )}
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => deleteConfirm(id)}
                className="text-danger"
              >
                <FontAwesomeIcon icon={faTrashAlt} className="mx-2" />
                <SafeFormatMessage id="Delete" />
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </td>
      </tr>
    )
  }
  const TableRows = () => {
    return (
      <Table hover className="user-table align-items-center">
        <thead>
          <tr>
            <th className="border-bottom">
              <SafeFormatMessage id="Display-Name" />
            </th>
            <th className="border-bottom">
              <SafeFormatMessage id="System-Name" />
            </th>
            <th className="border-bottom">
              <SafeFormatMessage id="Status" />
            </th>
            {!quickSetup && (
              <th className="border-bottom">
                <SafeFormatMessage id="Selection-Availability" />
              </th>
            )}
            <th className="border-bottom">
              <SafeFormatMessage id="Visibility-Status" />
            </th>
            {!quickSetup && (
              <th className="border-bottom">
                <SafeFormatMessage id="Tenancy-Type" />
              </th>
            )}
            {!quickSetup && (
              <th className="border-bottom">
                <SafeFormatMessage id="Subscribers" />
              </th>
            )}
            {/*<th className="border-bottom">
            <SafeFormatMessage id="Description" />
          </th>*/}
            {!quickSetup && (
              <th className="border-bottom">
                <SafeFormatMessage id="Display-Order" />
              </th>
            )}
            {!quickSetup && (
              <th className="border-bottom">
                <SafeFormatMessage id="Alternative-Plan" />
              </th>
            )}
            {ProductTrialType == 3 && (
              <th className="border-bottom">
                <SafeFormatMessage id="Trial-Period-In-Days" />
              </th>
            )}
            {!quickSetup && (
              <th className="border-bottom">
                <SafeFormatMessage id="System-Lock-Status" />
              </th>
            )}
            {!quickSetup && (
              <th className="border-bottom">
                <SafeFormatMessage id="Date" />
              </th>
            )}
            <th className="border-bottom">
              <SafeFormatMessage id="Actions" />
            </th>
          </tr>
        </thead>
        <tbody>
          {list?.plans && Object.values(list?.plans).length
            ? Object.values(list?.plans).map((t, index) => {
                return <TableRow key={index} {...t} />
              })
            : null}
        </tbody>
      </Table>
    )
  }

  return (
    <Wrapper>
      {!quickSetup && (
        <div className="dynamicButtons pt-0 mt-0 mb-1 d-flex justify-content-end">
          <span className="mx-2">
            <DynamicButtons
              buttons={[
                ...Object.keys({ en: 'English', ar: 'Arabic' }).map(
                  (lang, index) => ({
                    order: 1,
                    type: 'toggle',
                    label: lang,
                    group: 'language',
                    toggleValue: selectedLanguage === lang,
                    toggleFunc: () => setSelectedLanguage(lang),
                    variant: 'primary',
                  })
                ),
                {
                  order: 1,
                  type: 'form',
                  id: productId,
                  label: 'Add-Plan',
                  component: 'addPlan',
                  icon: <BsPencilSquare />,
                  setActiveIndex: setActiveIndex,
                },
              ]}
            />
          </span>
        </div>
      )}
      <div className={!quickSetup ? 'border-top-1 border-light' : 'mt-3'}>
        {quickSetup ? (
          <Card
            border="light"
            className="table-wrapper table-responsive shadow-sm"
            style={{ backgroundColor: 'var(--themeBackground)' }}
          >
            <Card.Body className="pt-0">
              <TableRows />
            </Card.Body>
          </Card>
        ) : (
          <Card
            border="light"
            className="table-wrapper table-responsive shadow-sm"
          >
            <Card.Body className="pt-0">
              <TableRows />
            </Card.Body>
          </Card>
        )}
        <DeleteConfirmation
          message={<SafeFormatMessage id="delete-plan-confirmation-message" />}
          icon="pi pi-exclamation-triangle"
          confirm={confirm}
          setConfirm={setConfirm}
          confirmFunction={handleDeletePlan}
          sideBar={false}
        />

        <ThemeDialog visible={visible} setVisible={setVisible}>
          <>
            <PlanForm
              popupLabel={<SafeFormatMessage id={popUpLable} />}
              type={type}
              setVisible={setVisible}
              sideBar={false}
              planData={type == 'edit' ? list?.plans[currentId] : {}}
            />
          </>
        </ThemeDialog>
      </div>
    </Wrapper>
  )
}

export default ProductPlansList
